// images/index.js
import key1 from './key1.png';
import key2 from './key2.png';
import stackOfCoins from './stack-of-coins.png';
import treasureChest from './treasure-chest.png';
import treasureChestOpen from './treasure-chest-open.png'; // Note: file names with spaces need to be wrapped in quotes

const images = {
  key1,
  key2,
  stackOfCoins,
  treasureChest,
  treasureChestOpen
};

export default images;
